export default "__VITE_ASSET__loaicjdd__"